import React, { useEffect, useState } from 'react';
import { LuLogOut } from "react-icons/lu";
import '../style/test.css'; // Import custom CSS for styling
import logo from '../img/vana png.png'; // Updated logo path
import { Link } from 'react-router-dom'; // Use react-router-dom Link for navigation
import { FaUserAlt, FaSignInAlt, FaPhoneAlt, FaMapMarkerAlt, FaTimes } from 'react-icons/fa'; // Importing the necessary icons
import { useLogout } from '../Functions/functions';

const Navbar = () => {
  const [account,setAccount]=useState(JSON.parse(localStorage.getItem('account')));
  const logout=useLogout();
 
  return (
    <div className='container-fluid p-0 fixed-top shadow'>
          <div className="top-decoration d-flex justify-content-between align-items-center">
        <div className="slogan">Simple Beginning to Unknown Horizon</div>
        <div className="contact-info">
          <span className="phone"><FaPhoneAlt /> +251 911 234 567</span> | 
          <span className="address"><FaMapMarkerAlt /> We are located near Bole Medhaniyalm</span>
        </div>
      </div>
       
            <nav className='navbar navbar-expand-sm navbar-light  bg-white w-100 '>
        <div className='container-fluid'>
            <div className='nav-brand p-1'>
            <img src={logo} alt="Vana Logo" loading='lazy' className="coffee-shop-logo" />
            </div>
            <button
            className="navbar-toggler"
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#mynavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
            <div className='collapse  navbar-collapse p-2 'id='mynavbar'>
                <ul className='navbar-nav  me-auto w-100 justify-content-center'>
                <li className="nav-item">
                <Link className="nav-link text-center" to="/" exact>
                  <i className="bi bi-house-door"></i> Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-center" to="/about">
                  <i className="bi bi-info-circle"></i> About Us
                </Link>
              </li>
            
              <li className="nav-item">
                <Link className="nav-link text-center" to="/tour" smooth={true} duration={500} spy={true} exact="true" offset={-70}>
                  <i className="bi bi-map"></i> Tours
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-center" to="/car" smooth={true} duration={500} spy={true} exact="true" offset={-70}>
                  <i className="bi bi-car-front"></i> Car Rentals
                </Link>
              </li>
             
              <li className="nav-item">
                <Link className="nav-link text-center" to="/Contact" smooth={true} duration={500} spy={true} exact="true" offset={-70}>
                  <i className="bi bi-envelope"></i> Contact Us
                </Link>
              </li>
                </ul>
                
                <div className="d-flex flex-column  flex-md-row ms-auto justify-content-center ">
              { !account && <>
                <Link to="/Login" className=" my-1 my-md-0 btn-login-register d-flex justify-content-center me-2">
                <FaSignInAlt /> Login
              </Link>
              <Link to="/Signup" className=" my-1 my-md-0 btn-login-register d-flex justify-content-center me-2">
                <FaUserAlt /> Register
              </Link>
              </>}
              {account && <>
                <Link to="/profile" className="mx-2 my-1 my-md-0 btn-login-register d-flex justify-content-center ">
                <FaUserAlt /> Profile
              </Link>
                <Link onClick ={logout}className='mx-2 my-1 my-md-0 btn-login-register d-flex justify-content-center'>
                <LuLogOut/> Logout
                </Link>
               
              </> }
             
            </div>
            </div>
        </div>
    </nav>
    </div>

  )
};

export default Navbar;






